import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';

let i18n;

// The list of supported languages (each language must have a file in the `langs` directory).
export const SUPPORT_LOCALES = ['ro', 'en'];

export function setI18nLanguage(locale) {
  loadLocaleMessages(locale);

  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }

  document.querySelector('html').setAttribute('lang', locale);
  localStorage.setItem('lang', locale);
}

export async function loadLocaleMessages(locale) {
  // load locale messages with dynamic import
  const messages = await import(
    /* webpackChunkName: "locale-[request]" */ `./langs/${locale}.js`
  );

  // set locale and locale message
  i18n.global.setLocaleMessage(locale, messages.default);

  return nextTick();
}

export default function setupI18n() {
  if(!i18n) {
    let locale = 'ro'
    if (localStorage.getItem('lang') == null || localStorage.getItem('lang') == 'ro')
      localStorage.setItem('lang', locale)

    i18n = createI18n({
      globalInjection: true,
      legacy: false,
      locale: locale,
      fallbackLocale: 'en'
    });

    setI18nLanguage(locale);
  }
  return i18n;
}
